import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.vehicleName) {
        errors.vehicleName = messages.required;
    } else if (values.vehicleName && values.vehicleName.trim().toString() == "") {
        errors.vehicleName = messages.required;
    } else if(values.vehicleName.length > inputTextLimit) {
        errors.vehicleName = messages.inputTextLimitError
    }

    if (!values.description) {
        errors.description = messages.required;
    } else if (values.description && values.description.trim().toString() == "") {
        errors.description = messages.required;
    } else if (values?.description?.length > inputDescLimit) {
        errors.description = messages.inputDescLimitError;
    }

    return errors;
};

export default validate;